(function(globals){

    var limit = function(limit, end = "...") {
        if(this.length <= limit) {
            return this;
        }

        return this.substring(0, limit) + end;
    };

    if (Object.defineProperty) {
        try {
            Object.defineProperty(String.prototype, 'limit', {
                value: limit, configurable: true, enumerable: false, writable: true
            });
        } catch(e) {}
    }

})(this);


// WEBPACK FOOTER //
// ./app/utils/string.prototype.limit.js